import { SessionResponse } from "./api-types";

export async function getSessionData(url: string) {
  const sessionUrl = new URL(url);
  const response = await fetch(sessionUrl, {});

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  const json = (await response.json()) as SessionResponse;

  return {
    manifestUrl: new URL(json.manifestUrl, sessionUrl).toString(),
    trackingData: json.trackingData,
  };
}
